<template>
    <button :class="selectedClasses"
            :style="variant === 'boxed-big' && {'height': '40px', 'padding': '5px 25px'}"
            @click.stop="buyItem"
            class="c-button"
            v-if="item.minPrice() > 0 || viewDetails || isFree || isGetQuote">
      <template v-if="isGetQuote">
        <font-awesome-icon class="c-button__left-icon" icon="envelope-open-dollar"></font-awesome-icon>
        Get Quote
      </template>
      <template v-else-if="item.minPrice() > 0 || isFree">
        <font-awesome-icon :icon="item.inCart() ? 'shopping-cart' : 'cart-plus'"
                           class="c-button__left-icon"></font-awesome-icon>
        <span v-if="item.inCart()">In Cart</span>
        <span v-else-if="variant === 'basic'">
            <template v-if="isFree">Free</template>
            <template v-else>Buy</template>
        </span>
        <span v-else-if="(forceText || !showPrice) && (variant === 'overImage' || variant === 'itemTileButton' || variant === 'boxed-big')">{{ label || 'Add To Cart'}}</span>
        <span v-else-if="!showPrice && variant === 'boxed'">Add</span>
        <span v-else>{{item.minPrice() | displayPrice(true)}}</span>
      </template>
      <template v-else-if="viewDetails">
        <font-awesome-icon icon="eye"
                           class="c-button__left-icon"></font-awesome-icon>
        <span>View<span v-if="(variant === 'overImage' || variant === 'itemTileButton')"> Details</span></span>
      </template>
    </button>
</template>

<script>
    export default {
        name: "buy-button",
        props: {
            forceText: {
                type: Boolean
            },
            variant: {
                type: String,
                default: 'boxed',
                validator: (value) => {
                    // The value must match one of these strings
                    return ['boxed-big', 'boxed', 'overImage', 'itemTileButton', 'basic'].indexOf(value) !== -1;
                }
            },
            item: {
                type: Object,
                required: true
            },
            label: {
                type: String
            }
        },
        data() {
            return {
                licenseModal: $("#buyLicenseModal"),
            }
        },
        computed: {
            isQuote() {
              return this.item.getType() === 'service_quote';
            },
            isGetQuote() {
              return this.item.getType() === 'service' && this.item.pricing_type === 'inquiry_required'
            },
            isFree() {
              return this.item.minPrice() === 0 && ['service'].includes(this.item.getType())
            },
            viewDetails() {
              return this.item.minPrice() === 0 && this.item.getType() === "soundkit"
            },
            showPrice() {
                return !this.$store.state.currentConfig.addToCartButtons;
            },
            selectedClasses() {
                return {
                    // Variant Related
                    'c-button--default': this.variant.startsWith('boxed') && !this.item.inCart(),
                    'c-button--shrinked': this.variant.startsWith('boxed'),
                    'c-button--over-image': this.variant === 'overImage',
                    'c-button--for-item-tile': this.variant === 'itemTileButton',


                    // State Related
                    'c-button--outline': this.item.inCart() && this.variant.startsWith('boxed')
                }
            }
        },
        methods: {
            openServiceInquiry() {
              this.$modal.show('service-inquiry', {
                service: this.item
              })
            },
            buyItem() {
                switch (this.item.getType()) {
                    case 'beat':
                        this.$store.commit("buyableBeat", {beat: this.item});
                        this.licenseModal.modal("show");
                        break;
                    case 'soundkit':
                        if (this.viewDetails) {
                          this.$router.push(`/soundkits/${this.item.id}`)
                        } else {
                          this.$modal.show("soundkit-pricing", { soundkit: this.item })
                        }
                        break;
                    case 'song':
                        this.item.addToCart();
                        break;
                    case 'service_quote':
                        this.item.addToCart();
                        break;
                    case 'beattapes':
                        this.item.addToCart();
                        break;
                    case 'service':
                        if (this.item.pricing_type === 'inquiry_required') {
                          this.openServiceInquiry()
                        } else {
                          this.item.addToCart();
                        }
                        break
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
</style>
